(() => {
  'use strict';

  const root = document.getElementById('snoga_api_results');
  if (!root || !root.classList.contains('snoga-api-results')) return;

  const apiKey = root.dataset.apiKey;
  const collectionHandle = root.dataset.collectionHandle;
  const collectionId = root.dataset.collectionId;
  const isSearch = root.dataset.mode === 'search' || !collectionHandle;
  const pageSize = Number(root.dataset.pageSize) || 24;
  const sourcePages = Number(root.dataset.sourcePages) || 1;
  const resultLabel = String(root.dataset.resultLabel || 'styles');
  const resultLabelSingular = String(root.dataset.resultLabelSingular || resultLabel.replace(/s$/, ''));
  const shop = root.querySelector('.snoga-api-shop');
  const rail = root.querySelector('#snogaApiRail');
  const grid = root.querySelector('[data-snoga-product-grid]');
  const facetHost = root.querySelector('[data-snoga-facets]');
  const chips = root.querySelector('[data-snoga-selected-filters]');
  const count = root.querySelector('[data-snoga-result-count]');
  const empty = root.querySelector('[data-snoga-empty]');
  const sentinel = root.querySelector('[data-snoga-sentinel]');
  const sort = root.querySelector('[data-snoga-sort]');
  const filterBadge = root.querySelector('[data-snoga-filter-count]');
  const resetButtons = root.querySelectorAll('[data-snoga-reset]');
  const toggle = root.querySelector('[data-snoga-toggle]');
  const closeButtons = root.querySelectorAll('[data-snoga-close]');
  const scrim = root.querySelector('[data-snoga-scrim]');
  const toolbar = root.querySelector('.toolbar');
  if (toolbar) {
    const updateToolbarStuck = () => toolbar.classList.toggle('is-stuck', toolbar.getBoundingClientRect().top <= 0);
    addEventListener('scroll', updateToolbarStuck, { passive: true });
    addEventListener('resize', updateToolbarStuck);
    updateToolbarStuck();
  }
  const cards = new Map([...grid.querySelectorAll('.collection-product-card')].map((card) => [card.dataset.productId, card]));
  const state = { facets: new Map(), price: null, skirtLength: null, sort: 'manual', startIndex: 0, total: 0, loading: false, requested: new Set(), sourcePage: 1 };
  const sortMap = {
    manual: isSearch ? { sortBy: 'relevance', sortOrder: 'asc' } : { sortBy: `collection_${collectionId}_position`, sortOrder: 'asc' },
    'best-selling': { sortBy: 'orders_count', sortOrder: 'desc' },
    'title-ascending': { sortBy: 'title', sortOrder: 'asc' },
    'title-descending': { sortBy: 'title', sortOrder: 'desc' },
    'price-ascending': { sortBy: 'price', sortOrder: 'asc' },
    'price-descending': { sortBy: 'price', sortOrder: 'desc' },
    'created-ascending': { sortBy: 'created_at', sortOrder: 'asc' },
    'created-descending': { sortBy: 'created_at', sortOrder: 'desc' }
  };
  // Kept in sync with the legacy Searchanise colour treatment.
  const swatchColors = {
    beige: '#d9cbb8', black: '#1a1a1a', blue: '#2f6fbd', brown: '#7a4a2b', 'dark blue': '#1d3557', navy: '#14213d', green: '#3a7d44', olive: '#6b8e23', grey: '#9a9a9a', gray: '#9a9a9a', orange: '#e07b39', pink: '#f4a7b9', purple: '#7d5ba6', red: '#c0392b', tan: '#d2b48c', turquoise: '#40e0d0', white: '#ffffff', yellow: '#f4d03f', charcoal: '#36454f', crimson: '#8b0000', burgundy: '#800020', lavender: '#b2a4d4', coral: '#ff7f50', gold: '#d4af37', silver: '#c0c0c0', khaki: '#c3b091', cream: '#fffdd0', mint: '#a8e6cf', peach: '#ffdab9', rust: '#b7410e', sage: '#9caf88', plum: '#8e4585', camo: 'repeating-linear-gradient(45deg,#4b5320 0px,#4b5320 20px,#3b3c36 20px,#3b3c36 40px,#4d3a2c 40px,#4d3a2c 60px,#918151 60px,#918151 80px)', floral: 'linear-gradient(135deg,#fff5f5 0%,#ffd3b6 50%,#ffaaa5 100%)', multi: 'linear-gradient(45deg,#c0392b,#f4d03f,#3a7d44,#2f6fbd)'
  };

  
  window.collectionHandle = collectionHandle;
  window.collectionId = collectionId;

  function setLoading(loading) { state.loading = loading; root.classList.toggle('is-loading', loading); }
  function openFilters() { shop.classList.add('is-open'); rail.classList.add('open'); toggle?.classList.add('is-active'); toggle?.setAttribute('aria-expanded', 'true'); if (matchMedia('(max-width: 900px)').matches) { sort?.blur(); scrim?.classList.add('show'); } }
  function closeFilters() { shop.classList.remove('is-open'); rail.classList.remove('open'); toggle?.classList.remove('is-active'); toggle?.setAttribute('aria-expanded', 'false'); scrim?.classList.remove('show'); }
  function encodeValue(value) { return String(value || '').replace(/\s+/g, '_'); }
  function decodeValue(value) { return String(value || '').replace(/_/g, ' '); }
  function escapeHtml(value) { const div = document.createElement('div'); div.textContent = String(value ?? ''); return div.innerHTML; }
  function keyForFacet(facet) { return String(facet.attribute || facet.key || facet.name || facet.field || facet.id || facet.title || facet.label || 'tags'); }
  function labelForFacet(facet) { return String(facet.label || facet.title || facet.name || facet.key || 'Filter').replace(/^_+|:+$/g, ''); }
  function swatchColor(value) { return swatchColors[String(value || '').replace(/_/g, ' ').toLowerCase().trim()] || ''; }
  // Real product swatch images (cdn) used for the sidebar color filters where one makes sense.
  const swatchImages = {
    black: 'swatch-black_camo.png', blue: 'swatch-blue_denim.png', brown: 'swatch-hot_fudge.png',
    navy: 'swatch-navy_blazer.png', white: 'swatch-brilliant_white.png',
    turquoise: 'swatch-pastel_turquoise.png', pink: 'swatch-cherry_blossom.png',
    green: 'swatch-martini_olive.png', camo: 'swatch-light_gray_camo.png' , floral: 'swatch-floral.png',
    hummus: 'swatch-hummus.png', 'festival fuchsia': 'swatch-festival_fuchsia.png', 'festival fuschia': 'swatch-festival_fuchsia.png'
  };
  
  const SWATCH_BASE = '/cdn/shop/files/';
  function swatchImage(value) {
    const key = String(value || '').replace(/_/g, ' ').toLowerCase().trim();
    const slug = swatchImages[key];
    return slug ? `${SWATCH_BASE}${slug}?width=300` : '';
  }
  // Deterministic colour so an unknown color name never renders a blank swatch.
  const fallbackPalette = ['#c0392b', '#2f6fbd', '#7a4a2b', '#3a7d44', '#7d5ba6', '#e07b39', '#40e0d0', '#8e4585', '#b7410e', '#36454f'];
  function fallbackHex(value) {
    const key = String(value || '').replace(/_/g, ' ').toLowerCase().trim();
    let hash = 0;
    for (let i = 0; i < key.length; i++) hash = (hash * 31 + key.charCodeAt(i)) >>> 0;
    return fallbackPalette[hash % fallbackPalette.length];
  }
  function swatchStyle(value, raw) {
    const image = swatchImage(raw);
    if (image) return `background-image:url(&quot;${image}&quot;);background-size:cover;background-position:center`;
    const code = String(value.color_code || '').trim().toLowerCase();
    if (/^[0-9a-f]{3}([0-9a-f]{3})?$/.test(code)) return `background-color:#${code}`;
    const colour = swatchColor(raw);
    if (colour) return `background:${colour}`;
    if (value.image_url) return `background-image:url(&quot;${escapeHtml(value.image_url)}&quot;);background-size:cover;background-position:center`;
    return `background:${fallbackHex(raw)}`;
  }

  function readUrl() {
    const params = new URLSearchParams(location.search);
    state.sort = params.get('sort_by') || 'manual';
    state.price = params.has('snoga_price_min') || params.has('snoga_price_max') ? { min: params.get('snoga_price_min') || '', max: params.get('snoga_price_max') || '' } : null;
    state.skirtLength = params.has('snoga_skirt_min') || params.has('snoga_skirt_max') ? { min: params.get('snoga_skirt_min') || '', max: params.get('snoga_skirt_max') || '' } : null;
    params.forEach((value, key) => {
      if (!key.startsWith('snoga_f_')) return;
      const facet = decodeURIComponent(key.slice(8));
      state.facets.set(facet, new Set(value.split('|').filter(Boolean).map(decodeValue)));
    });
    if (sort) sort.value = state.sort;
  }

  function writeUrl() {
    const url = new URL(location.href);
    [...url.searchParams.keys()].filter((key) => key.startsWith('snoga_f_') || key === 'snoga_price_min' || key === 'snoga_price_max' || key === 'snoga_skirt_min' || key === 'snoga_skirt_max' || key === 'sort_by').forEach((key) => url.searchParams.delete(key));
    state.facets.forEach((values, facet) => { if (values.size) url.searchParams.set(`snoga_f_${encodeURIComponent(facet)}`, [...values].map(encodeValue).join('|')); });
    if (state.price?.min) url.searchParams.set('snoga_price_min', state.price.min);
    if (state.price?.max) url.searchParams.set('snoga_price_max', state.price.max);
    if (state.skirtLength?.min) url.searchParams.set('snoga_skirt_min', state.skirtLength.min);
    if (state.skirtLength?.max) url.searchParams.set('snoga_skirt_max', state.skirtLength.max);
    if (state.sort && state.sort !== 'manual') url.searchParams.set('sort_by', state.sort);
    history.pushState({}, '', url);
  }

  function buildRequest(startIndex, sortOverride) {
    const query = new URLSearchParams({ api_key: apiKey, facets: 'true', items: 'true', maxResults: String(pageSize), startIndex: String(startIndex), output: 'json' });
    if (!isSearch) query.set('collection', collectionHandle);
    const sortOption = sortOverride || sortMap[state.sort] || sortMap.manual;
    query.set('sortBy', sortOption.sortBy); query.set('sortOrder', sortOption.sortOrder);
    state.facets.forEach((values, facet) => {
      if (values.size) query.set(`restrictBy[${facet}]`, [...values].join('|'));
    });
    if (state.price && (state.price.min || state.price.max)) query.set('restrictBy[price]', `${state.price.min || 0},${state.price.max || ''}`);
    const q = new URLSearchParams(location.search).get('q'); if (q) query.set('q', q);
    return `https://searchserverapi1.com/getresults?${query}`;
  }

  function responseItems(response) { return response.items || response.results || response.products || []; }
  function itemId(item) { return String(item.product_id || item.productId || item.id || item.product?.id || ''); }
  function totalItems(response) { return Number(response.totalItems ?? response.total_items ?? response.total ?? response.count ?? 0); }
  function normaliseFacets(raw) {
    if (Array.isArray(raw)) return raw;
    if (raw && typeof raw === 'object') return Object.entries(raw).map(([key, facet]) => ({ key, ...(Array.isArray(facet) ? { values: facet } : facet) }));
    return [];
  }
  function facetValues(facet) {
    const values = facet.buckets || facet.values || facet.options || facet.items || [];
    if (Array.isArray(values)) return values.map((value) => typeof value === 'object' ? value : { value, label: value });
    if (values && typeof values === 'object') return Object.entries(values).map(([value, data]) => typeof data === 'object' ? { value, ...data } : { value, count: data });
    return [];
  }
  function renderFacetValue(value, key, color) {
    const raw = String(value.value ?? value.key ?? value.label ?? value.title ?? '');
    const label = String(value.title ?? value.label ?? raw).replace(/_/g, ' ');
    const selected = state.facets.get(key)?.has(raw);
    const disabled = Number(value.count) === 0 && !selected;
    if (color) return `<li><label class="filter-group__item snoga-swatch${selected ? ' is-checked' : ''}${disabled ? ' filter-group__item--disabled' : ''}" data-label="${escapeHtml(label)}"><input class="filter-group__checkbox" type="checkbox" value="${escapeHtml(raw)}" ${selected ? 'checked' : ''} ${disabled ? 'disabled' : ''}><span class="snoga-swatch-dot" style="${swatchStyle(value, raw)}"></span><span class="visually-hidden">${escapeHtml(label)}</span></label></li>`;
    return `<label class="filter-group__item${selected ? ' on' : ''}${disabled ? ' filter-group__item--disabled' : ''}"><input class="filter-group__checkbox" type="checkbox" value="${escapeHtml(raw)}" ${selected ? 'checked' : ''} ${disabled ? 'disabled' : ''}><span class="label-text">${escapeHtml(label)}</span>${value.count != null ? `<span class="count">${escapeHtml(value.count)}</span>` : ''}</label>`;
  }

  function openGroupKeys() {
    const open = new Set();
    facetHost.querySelectorAll('.fgroup.is-open').forEach((section) => {
      const key = section.dataset.snogaFacet || section.querySelector('.fgroup-head h4')?.textContent.trim();
      if (key) open.add(key);
    });
    return open;
  }
  function restoreOpenGroups(keys) {
    keys.forEach((key) => {
      const section = facetHost.querySelector(`[data-snoga-facet="${CSS.escape(key)}"]`)
        || [...facetHost.querySelectorAll('.fgroup')].find((s) => s.querySelector('.fgroup-head h4')?.textContent.trim() === key);
      if (section) { section.classList.add('is-open'); section.querySelector('.fgroup-head')?.setAttribute('aria-expanded', 'true'); }
    });
  }

  function renderFacets(rawFacets) {
    const openBefore = openGroupKeys();
    const facets = normaliseFacets(rawFacets).filter((facet) => (facet.type === 'price' || /price/i.test(keyForFacet(facet))) || facetValues(facet).length > 1);
    const order = ['length', 'color', 'size', 'price'];
    facets.sort((a, b) => {
      const aKey = keyForFacet(a); const bKey = keyForFacet(b);
      const aLabel = labelForFacet(a).toLowerCase(); const bLabel = labelForFacet(b).toLowerCase();
      const aIsPrice = a.type === 'price' || /price/i.test(aKey);
      const bIsPrice = b.type === 'price' || /price/i.test(bKey);
      const aIdx = aIsPrice ? 3 : order.findIndex((o) => aKey.toLowerCase().includes(o) || aLabel.includes(o));
      const bIdx = bIsPrice ? 3 : order.findIndex((o) => bKey.toLowerCase().includes(o) || bLabel.includes(o));
      return (aIdx === -1 ? 99 : aIdx) - (bIdx === -1 ? 99 : bIdx);
    });
    facetHost.innerHTML = facets.map((facet) => {
      const key = keyForFacet(facet); const label = labelForFacet(facet); const isPrice = facet.type === 'price' || /price/i.test(key);
      if (isPrice) {
        const bucket = facetValues(facet)[0] || {};
        const minimum = Number(bucket.from ?? bucket.left ?? 0);
        const maximum = Number(bucket.to ?? bucket.right ?? 0);
        if (minimum === maximum) return '';
        const range = maximum - minimum;
        const step = range <= 60 ? 15 : range <= 120 ? 25 : 50;
        const buckets = [];
        for (let lo = minimum; lo < maximum; lo += step) {
          const hi = Math.min(lo + step, maximum);
          buckets.push({ min: lo, max: hi, label: lo === minimum ? `Under $${hi}` : hi === maximum ? `$${lo} & up` : `$${lo} – $${hi}` });
        }
        const activeMin = state.price?.min === '' || state.price?.min == null ? null : Number(state.price.min);
        const activeMax = state.price?.max === '' || state.price?.max == null ? null : Number(state.price.max);
        const buttons = buckets.map((b) => {
          const active = activeMin != null && activeMax != null && Number(activeMin) === b.min && Number(activeMax) === b.max;
          return `<button type="button" class="pr${active ? ' on' : ''}" data-snoga-price-btn data-min="${b.min}" data-max="${b.max}"><span class="dot"></span> ${escapeHtml(b.label)}</button>`;
        }).join('');
        return `<section class="fgroup is-open" data-snoga-price-group data-snoga-price-floor="${minimum}" data-snoga-price-ceiling="${maximum}"><button type="button" class="fgroup-head" aria-expanded="true"><h4>${escapeHtml(label)}</h4></button><div class="fgroup-body"><div class="pricecol" data-group="price">${buttons}</div></div></section>`;
      }
      const values = facetValues(facet); const color = /color/i.test(label) || /^_?color/.test(key); const size = /size/i.test(label);
      const isSkirtLength = /skirt\s*length/i.test(label) && values.some((v) => !isNaN(Number(v.value)));
      if (isSkirtLength) {
        const nums = values.map((v) => Number(v.value)).filter((n) => Number.isFinite(n));
        const minimum = Math.min(...nums);
        const maximum = Math.max(...nums);
        if (minimum === maximum && nums.length <= 1) return '';
        const lengthMap = [
          { match: (n) => n <= 19, label: 'Above knee', small: `${minimum}″` },
          { match: (n) => n >= 20 && n <= 22, label: 'Knee length', small: `${Math.min(...nums.filter(n => n >= 20 && n <= 22))}″` },
          { match: (n) => n >= 24 && n <= 26, label: 'Midi', small: '24–26″' },
          { match: (n) => n >= 27 && n <= 30, label: 'Capri', small: '¾' },
          { match: (n) => n >= 31, label: 'Full length', small: `${maximum}″` }
        ];
        const availLabels = lengthMap.filter((cat) => nums.some((n) => cat.match(n)));
        const activeVals = state.facets.get(key) || new Set();
        const buttons = availLabels.map((cat) => {
          const matchingNums = nums.filter((n) => cat.match(n));
          const active = matchingNums.every((n) => activeVals.has(String(n)));
          return `<button type="button" class="lenpill${active ? ' on' : ''}" data-snoga-length-btn data-values="${matchingNums.join(',')}">${escapeHtml(cat.label)} <small>${escapeHtml(cat.small)}</small></button>`;
        }).join('');
        return `<section class="fgroup is-open" data-snoga-facet="${escapeHtml(key)}"><button type="button" class="fgroup-head" aria-expanded="true"><h4>${escapeHtml(label)}</h4></button><div class="fgroup-body"><div class="lenpills">${buttons}</div></div></section>`;
      }
      const typeClass = color ? 'fg-swatch' : size ? 'fg-size' : 'fg-list';
      const listTag = color ? 'ul' : 'div';
      const listClass = color ? 'snize-product-filters-list snoga-tag-colors' : typeClass;
      return `<section class="fgroup is-open" data-snoga-facet="${escapeHtml(key)}"><button type="button" class="fgroup-head" aria-expanded="true"><h4>${escapeHtml(label)}</h4></button><div class="fgroup-body"><${listTag} class="${listClass}">${values.map((value) => renderFacetValue(value, key, color)).join('')}</${listTag}></div></section>`;
    }).join('');
    restoreOpenGroups(openBefore);
  }

  function renderSelected() {
    const selected = [];
    state.facets.forEach((values, facet) => values.forEach((value) => selected.push({ facet, value })));
    if (state.price && (state.price.min || state.price.max)) selected.push({ price: true, value: `$${state.price.min || '0'} – $${state.price.max || '∞'}` });
    if (state.skirtLength && (state.skirtLength.min || state.skirtLength.max)) selected.push({ skirtLength: true, value: `Length: ${state.skirtLength.min || '0'}\" – ${state.skirtLength.max || '∞'}"` });
    chips.innerHTML = selected.map((item, index) => `<span class="achip">${escapeHtml(String(item.value).replace(/_/g, ' '))}<button type="button" data-snoga-remove="${index}" aria-label="Remove ${escapeHtml(item.value)}">&times;</button></span>`).join('') + (selected.length ? '<span class="achip clr"><button type="button" data-snoga-reset>Clear all</button></span>' : '');
    chips._selected = selected;
    filterBadge.hidden = !selected.length; filterBadge.textContent = selected.length;
    resetButtons.forEach((button) => { button.hidden = !selected.length; });
  }

  async function ensureCards(ids) {
    const missing = () => ids.filter((id) => !cards.has(id));
    while (missing().length && state.sourcePage < sourcePages) {
      state.sourcePage += 1;
      const url = new URL(location.href); url.searchParams.delete('page'); url.searchParams.set('page', state.sourcePage);
      try {
        const html = await fetch(url.toString(), { credentials: 'same-origin' }).then((response) => response.text());
        const documentFragment = new DOMParser().parseFromString(html, 'text/html');
        documentFragment.querySelectorAll('.collection-product-card').forEach((card) => {
          if (!card.dataset.productId || cards.has(card.dataset.productId)) return;
          card.classList.remove('active'); cards.set(card.dataset.productId, card); grid.appendChild(card);
        });
      } catch (_) { break; }
    }
  }

  async function renderItems(items, append) {
    const ids = items.map(itemId).filter(Boolean);
    await ensureCards(ids);
    if (!append) cards.forEach((card) => card.classList.remove('active'));
    ids.forEach((id, index) => {
      const card = cards.get(id);
      if (card) { card.classList.add('active'); card.style.order = String(state.startIndex + index); }
    });
    renderCardSwatches();
  }

  const shopUrl = root.dataset.shopUrl;
  const colorToken = root.dataset.colorToken;
  const swatchGroupCache = new Map();
  // Shared with the collection quick-add picker. Each entry retains the product
  // handle, so a visual swatch can be matched to that product's real variants.
  const quickAddSwatches = window.snogaCollectionSwatches = window.snogaCollectionSwatches || {};
  const swatchFetching = new Set();

  function cardSwatchStyle(label, imageUrl) {
    if (imageUrl) return `background-image:url(&quot;${imageUrl}&quot;);background-size:cover;background-position:center`;
    return `background:${swatchColor(label) || fallbackHex(label)}`;
  }

  function ajaxVariantId(id) {
    const match = String(id || '').match(/(\d+)$/);
    return match ? Number(match[1]) : null;
  }

  async function fetchSwatchGroup(group) {
    if (swatchGroupCache.has(group)) return swatchGroupCache.get(group);
    if (swatchFetching.has(group)) return null;
    if (!shopUrl || !colorToken) return [];
    swatchFetching.add(group);
    try {
      const query = `{ products(first: 100, query: "tag:'_collection:${group}'") { edges { node { handle title tags featuredImage { url(transform: {maxWidth: 300}) } variants(first: 100) { edges { node { id availableForSale selectedOptions { name value } } } } } } } }`;
      const response = await fetch(`${shopUrl}/api/2024-07/graphql.json`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': colorToken },
        body: JSON.stringify({ query })
      });
      const res = await response.json();
      const colors = [];
      (((res.data && res.data.products) || {}).edges || []).forEach((edge) => {
        const p = edge.node;
        let imageUrl = null;
        let label = p.title;
        (p.tags || []).forEach((t) => {
          if (t.indexOf('_swatch:') === 0) imageUrl = `/cdn/shop/files/${t.split(':')[1]}?width=300`;
          if (t.indexOf('_swatch_label:') === 0) label = t.split(':')[1].replace(/_/g, ' ');
        });
        const style = cardSwatchStyle(label, imageUrl);
        const variants = (((p.variants || {}).edges) || []).map(({ node }) => ({
          id: ajaxVariantId(node.id),
          available: Boolean(node.availableForSale),
          options: node.selectedOptions || []
        })).filter((variant) => variant.id);
        if (!colors.some((c) => c.handle === p.handle)) colors.push({ label, style, handle: p.handle, variants });
      });
      swatchGroupCache.set(group, colors);
      quickAddSwatches[group] = colors;
      document.dispatchEvent(new CustomEvent('snoga:swatches-ready', { detail: { group } }));
      return colors;
    } catch (_) { return []; }
    finally { swatchFetching.delete(group); }
  }

  async function renderCardSwatches() {
    const hosts = [...root.querySelectorAll('.collection-product-card [data-card-swatches]')];
    const byGroup = new Map();
    hosts.forEach((host) => {
      const group = host.closest('.collection-product-card')?.dataset.colorGroup || '';
      if (!group) return;
      const list = byGroup.get(group) || [];
      list.push(host);
      byGroup.set(group, list);
    });
    await Promise.all([...byGroup.keys()].map(fetchSwatchGroup));
    byGroup.forEach((groupHosts, group) => {
      const colors = swatchGroupCache.get(group) || [];
      if (!colors.length) return;
      const dots = colors.slice(0, 4).map((c) => `<i style="${c.style}" title="${escapeHtml(c.label)}"></i>`).join('');
      const countLabel = `${colors.length} ${colors.length === 1 ? 'color' : 'colors'}`;
      groupHosts.forEach((host) => { if (!host.dataset.loaded) { host.innerHTML = `${dots}<b>${countLabel}</b>`; host.dataset.loaded = 'true'; } });
    });
  }

  async function request({ append = false, pushUrl = false } = {}) {
    if (state.loading) return;
    if (!apiKey) {
      showFailure('Search filters are unavailable until a public Searchanise API key is configured.');
      cards.forEach((card) => card.classList.add('active'));
      sentinel.hidden = true;
      return;
    }
    const requestIndex = append ? state.startIndex : 0;
    if (append && state.requested.has(requestIndex)) return;
    setLoading(true); if (pushUrl) writeUrl();
    try {
      /* Searchanise needs a per-collection "position" sort attribute for the
         default (featured/manual) order. If it isn't configured, the request
         fails with SORT_ATTRIBUTE_WASNT_FOUND and the whole collection would
         look empty. Retry once with a safe fallback sort so published products
         always render. */
      const FALLBACK_SORT = { sortBy: 'title', sortOrder: 'asc' };
      let response = await fetch(buildRequest(requestIndex)).then((result) => { if (!result.ok) throw new Error(`Searchanise request failed (${result.status})`); return result.json(); });
      if (response && response.error === 'SORT_ATTRIBUTE_WASNT_FOUND' && (sortMap[state.sort] || sortMap.manual).sortBy === `collection_${collectionId}_position`) {
        console.warn('[snoga] Searchanise was missing the collection position sort; falling back to newest-first.', response);
        response = await fetch(buildRequest(requestIndex, FALLBACK_SORT)).then((result) => { if (!result.ok) throw new Error(`Searchanise request failed (${result.status})`); return result.json(); });
      }
      const items = responseItems(response); state.total = totalItems(response); state.startIndex = append ? state.startIndex + items.length : items.length; state.requested.add(requestIndex);
      await renderItems(items, append); window._lastRawFacets = response.facets; renderFacets(response.facets); facetHost.querySelectorAll('[data-snoga-price-group]').forEach((group) => syncPriceSlider(group)); facetHost.querySelectorAll('[data-snoga-skirt-group]').forEach((group) => syncSkirtSlider(group)); renderSelected();
      /* If Searchanise has no index/items for this collection (even after a
         reindex) but the server rendered product cards and no filter is active,
         show those cards instead of a bare "No results" — the collection must
         never appear empty when it has published products. */
      const noActiveFilters = state.facets.size === 0 && !state.price && !state.skirtLength;
      const serverCards = [...grid.querySelectorAll('.collection-product-card')];
      if (state.total === 0 && !isSearch && noActiveFilters && serverCards.length) {
        serverCards.forEach((card) => card.classList.add('active'));
        count.textContent = `${serverCards.length} ${serverCards.length === 1 ? resultLabelSingular : resultLabel}`;
        empty.classList.remove('show');
        sentinel.hidden = true;
      } else {
        count.textContent = `${state.total} ${state.total === 1 ? resultLabelSingular : resultLabel}`;
        empty.classList.toggle('show', state.total === 0);
        sentinel.hidden = state.startIndex >= state.total;
      }
    } catch (error) { showFailure('We couldn’t update these filters. Your collection is still available below.'); cards.forEach((card) => card.classList.add('active')); console.warn('[snoga] Searchanise API', error); }
    finally { setLoading(false); }
  }

  function showFailure(message) { count.textContent = message; }
  function openCartDrawer(opener) {
    const previewTrigger = document.querySelector('.cart-pill');
    if (previewTrigger) {
      // Keep the existing cart-pill listener in charge of opening its preview
      // drawer, but never allow this programmatic click to follow its /cart URL.
      previewTrigger.addEventListener('click', (event) => event.preventDefault(), { capture: true, once: true });
      previewTrigger.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
      return;
    }
    const drawer = document.querySelector('.js-cart-drawer');
    if (drawer && typeof drawer.open === 'function') { drawer.open(opener); return; }
    document.dispatchEvent(new CustomEvent('theme:open-cart-drawer', { bubbles: true }));
  }
  function updateCartCount(itemCount) {
    document.querySelectorAll('[data-ajax-cart-bubble], .cart-link__count').forEach((bubble) => { bubble.textContent = itemCount > 0 ? itemCount : ''; });
    document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));
  }
  async function quickAdd(button) {
    const card = button.closest('.collection-product-card'); const variantId = card?.dataset.variantId;
    if (!variantId || button.disabled) return;
    const label = button.textContent; button.disabled = true; button.textContent = 'Adding…';
    try {
      const rootPath = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${rootPath}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }) });
      if (!response.ok) throw new Error('Unable to add this product to cart');
      const cart = await fetch(`${rootPath}cart.js`, { headers: { Accept: 'application/json' } }).then((result) => result.json());
      updateCartCount(cart.item_count); openCartDrawer(button);
    } catch (error) { console.warn('[snoga] Quick add failed', error); button.textContent = 'Try again'; }
    finally { button.disabled = false; if (button.textContent === 'Adding…') button.textContent = label; }
  }
  function syncPriceSlider(group, source) {
    if (!group) return;
    const floor = Number(group.dataset.snogaPriceFloor); const ceiling = Number(group.dataset.snogaPriceCeiling);
    const minRange = group.querySelector('[data-snoga-range-min]'); const maxRange = group.querySelector('[data-snoga-range-max]');
    const minInput = group.querySelector('[data-snoga-price-min]'); const maxInput = group.querySelector('[data-snoga-price-max]');
    if (!minRange || !maxRange || !minInput || !maxInput || !Number.isFinite(floor) || !Number.isFinite(ceiling)) return;
    let minimum = Number(source === minRange ? minRange.value : minInput.value || floor);
    let maximum = Number(source === maxRange ? maxRange.value : maxInput.value || ceiling);
    minimum = Math.max(floor, Math.min(minimum, maximum)); maximum = Math.min(ceiling, Math.max(maximum, minimum));
    minRange.value = String(minimum); maxRange.value = String(maximum);
    if (source === minRange || source === maxRange) { minInput.value = String(minimum); maxInput.value = String(maximum); }
    const span = Math.max(1, ceiling - floor); const left = ((minimum - floor) / span) * 100; const right = 100 - ((maximum - floor) / span) * 100;
    const selected = group.querySelector('.selected-bar'); if (selected) { selected.style.left = `${left}%`; selected.style.right = `${right}%`; }
  }
  function syncSkirtSlider(group, source) {
    if (!group) return;
    const floor = Number(group.dataset.snogaSkirtFloor); const ceiling = Number(group.dataset.snogaSkirtCeiling);
    const minRange = group.querySelector('[data-snoga-skirt-range-min]'); const maxRange = group.querySelector('[data-snoga-skirt-range-max]');
    const minInput = group.querySelector('[data-snoga-skirt-min]'); const maxInput = group.querySelector('[data-snoga-skirt-max]');
    if (!minRange || !maxRange || !minInput || !maxInput || !Number.isFinite(floor) || !Number.isFinite(ceiling)) return;
    let minimum = Number(source === minRange ? minRange.value : minInput.value || floor);
    let maximum = Number(source === maxRange ? maxRange.value : maxInput.value || ceiling);
    minimum = Math.max(floor, Math.min(minimum, maximum)); maximum = Math.min(ceiling, Math.max(maximum, minimum));
    minRange.value = String(minimum); maxRange.value = String(maximum);
    if (source === minRange || source === maxRange) { minInput.value = String(minimum); maxInput.value = String(maximum); }
    const span = Math.max(1, ceiling - floor); const left = ((minimum - floor) / span) * 100; const right = 100 - ((maximum - floor) / span) * 100;
    const selected = group.querySelector('.selected-bar'); if (selected) { selected.style.left = `${left}%`; selected.style.right = `${right}%`; }
  }
  function reset() { state.facets.clear(); state.price = null; state.skirtLength = null; state.startIndex = 0; state.requested.clear(); request({ pushUrl: true }); }
  function applyFilters() { state.startIndex = 0; state.requested.clear(); request({ pushUrl: true }); }

  root.addEventListener('click', (event) => {
    const quickAddButton = event.target.closest('[data-snoga-quick-add]'); if (quickAddButton) { event.preventDefault(); quickAdd(quickAddButton); return; }
    const priceBtn = event.target.closest('[data-snoga-price-btn]');
    if (priceBtn) {
      const wasOn = priceBtn.classList.contains('on');
      const group = priceBtn.closest('[data-snoga-price-group]');
      group.querySelectorAll('[data-snoga-price-btn]').forEach((b) => b.classList.remove('on'));
      if (wasOn) { state.price = null; } else { priceBtn.classList.add('on'); state.price = { min: String(priceBtn.dataset.min), max: String(priceBtn.dataset.max) }; }
      applyFilters(); return;
    }
    const lengthBtn = event.target.closest('[data-snoga-length-btn]');
    if (lengthBtn) {
      const section = lengthBtn.closest('.fgroup');
      const facetKey = section?.dataset.snogaFacet;
      if (facetKey) {
        const values = state.facets.get(facetKey) || new Set();
        const btnVals = (lengthBtn.dataset.values || '').split(',').filter(Boolean);
        const allActive = btnVals.every((v) => values.has(v));
        if (allActive) { btnVals.forEach((v) => values.delete(v)); } else { btnVals.forEach((v) => values.add(v)); }
        values.size ? state.facets.set(facetKey, values) : state.facets.delete(facetKey);
        lengthBtn.classList.toggle('on', !allActive);
        applyFilters(); return;
      }
    }
    if (event.target.closest('[data-snoga-reset]')) { reset(); return; }
    const remove = event.target.closest('[data-snoga-remove]'); if (remove) { const item = chips._selected?.[Number(remove.dataset.snogaRemove)]; if (item?.price) state.price = null; else if (item?.skirtLength) state.skirtLength = null; else if (item) { const values = state.facets.get(item.facet); values?.delete(item.value); if (!values?.size) state.facets.delete(item.facet); } applyFilters(); return; }
  });
  facetHost.addEventListener('change', (event) => {
    const input = event.target; const section = input.closest('[data-snoga-facet]');
    if (section && input.matches('input[type="checkbox"]')) { const key = section.dataset.snogaFacet; const values = state.facets.get(key) || new Set(); input.checked ? values.add(input.value) : values.delete(input.value); values.size ? state.facets.set(key, values) : state.facets.delete(key); applyFilters(); }
  });
  sort?.addEventListener('change', () => { state.sort = sort.value; applyFilters(); });
  toggle?.addEventListener('click', () => shop.classList.contains('is-open') ? closeFilters() : openFilters());
  closeButtons.forEach((button) => button.addEventListener('click', closeFilters));
  scrim?.addEventListener('click', closeFilters);
  addEventListener('popstate', () => { state.facets.clear(); readUrl(); state.startIndex = 0; state.requested.clear(); request(); });
  if ('IntersectionObserver' in window) new IntersectionObserver((entries) => { if (entries[0].isIntersecting && !state.loading && state.startIndex < state.total) request({ append: true }); }, { rootMargin: '250px' }).observe(sentinel);

  if (isSearch && !new URLSearchParams(location.search).get('q')) return;
  readUrl();
  request();
  renderCardSwatches();
})();
